import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Code2, Building2, MessageSquare, BookOpen } from "lucide-react";

const navItems = [
  { path: "/algorithms", label: "Algorithms", icon: Code2 },
  { path: "/system-design", label: "System Design", icon: Building2 },
  { path: "/behavioral", label: "Behavioral", icon: MessageSquare },
  { path: "/blog", label: "Blog", icon: BookOpen },
];

const MobileNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-gray-900 border-t border-gray-800 lg:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const active = isActive(item.path);
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-xl transition-colors ${
                active
                  ? "text-emerald-400"
                  : "text-gray-500 hover:text-gray-300"
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
